import { LitElement, html } from "../vendor/lit-element/lit-element";
import { STATES } from "./cbDetailStates";

class ClinicalBurdens extends LitElement {
  constructor() {
    super();

    this.colors = {
      hoverables: {
        active: "#8cf58c",
        inactive: "#bfb8ff",
      },
      wedge: {
        inner: {
          active: "#38a947",
          inactive: "#ececec",
        },
        outer: {
          active: "#389d45",
          inactive: "#e4e4e4",
        },
        text: {
          active: "#ffffff",
          inactive: "#38a947",
        },
      },
    };
  }

  _handleMouseEnter(id) {
    const hoverables = document.querySelectorAll(".hoverable");
    const wedges = {
      inner: document.querySelectorAll(".inner-wedge"),
      outer: document.querySelectorAll(".outer-wedge"),
      text: document.querySelectorAll(".text > path"),
    };

    const activeHoverable = document.getElementById(id);
    const selectorBase = id.split("-")[1]; // yes, i know.

    const activeWedgeInner = document.getElementById(
      `inner-wedge-${selectorBase}`
    );
    const activeWedgeOuter = document.getElementById(
      `outer-wedge-${selectorBase}`
    );
    const activeText = document.querySelectorAll(
      `.${selectorBase}-text > path`
    );

    hoverables.forEach((el) => {
      el.style.fill = this.colors.hoverables.inactive;
    });

    wedges.inner.forEach((el) => {
      el.style.fill = this.colors.wedge.inner.inactive;
    });

    wedges.outer.forEach((el) => {
      el.style.fill = this.colors.wedge.outer.inactive;
    });

    wedges.text.forEach((el) => {
      el.style.fill = this.colors.wedge.text.inactive;
    });

    activeHoverable.style.fill = this.colors.hoverables.active;
    activeWedgeInner.style.fill = this.colors.wedge.inner.active;
    activeWedgeOuter.style.fill = this.colors.wedge.outer.active;
    activeText.forEach((el) => {
      el.style.fill = this.colors.wedge.text.active;
    });
  }

  _handleDisease() {
    this._handleMouseEnter("hoverable-disease");
    const event = new CustomEvent("detail-changed", {
      detail: {
        state: STATES.disease,
      },
    });
    this.dispatchEvent(event);
  }

  _handleDiseaseGlass() {
    this._handleMouseEnter("hoverable-disease-glass");
    const event = new CustomEvent("detail-changed", {
      detail: {
        state: STATES.diseaseGlass,
      },
    });
    this.dispatchEvent(event);
  }

  _handleMortality() {
    this._handleMouseEnter("hoverable-mortality");
    const event = new CustomEvent("detail-changed", {
      detail: {
        state: STATES.mortality,
      },
    });
    this.dispatchEvent(event);
  }

  _handleMortalityGlass() {
    this._handleMouseEnter("hoverable-mortality-glass");
    const event = new CustomEvent("detail-changed", {
      detail: {
        state: STATES.mortalityGlass,
      },
    });
    this.dispatchEvent(event);
  }

  _handleBone() {
    this._handleMouseEnter("hoverable-bone");
    const event = new CustomEvent("detail-changed", {
      detail: {
        state: STATES.bone,
      },
    });
    this.dispatchEvent(event);
  }

  _handleBoneGlass() {
    this._handleMouseEnter("hoverable-bone-glass");
    const event = new CustomEvent("detail-changed", {
      detail: {
        state: STATES.boneGlass,
      },
    });
    this.dispatchEvent(event);
  }

  // This is needed to not append the render() result to a shadow dom (so that we can select elements.)
  createRenderRoot() {
    return this;
  }

  render() {
    return html`
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 461.18 413.3"
      >
        <g style="isolation: isolate">
          <path
            d="M229.42,389.13a186.47,186.47,0,0,1-93.07-25c-28.47-16.44-48.91-36.3-65.71-64l91.88-53.05a80.61,80.61,0,0,0,67.06,35.34,81.79,81.79,0,0,0,67.06-35.36l91.9,53.06a186.37,186.37,0,0,1-159.11,89Z"
            style="fill: #ececec"
            class="inner-wedge-bone inner-wedge"
            id="inner-wedge-bone"
          />
          <path
            d="M298,253.68l83.49,48.2a181.41,181.41,0,0,1-242.68,57.91c-26.19-15.13-45.4-33.22-61.23-57.89l83.51-48.21a86.24,86.24,0,0,0,136.91,0m-3-13.3a76.3,76.3,0,0,1-130.87,0l-100.39,58c17.61,30.49,39.59,52.48,70.09,70.09a191.42,191.42,0,0,0,261.58-70.09L295,240.38Z"
            style="fill: #e4e4e4"
            class="outer-wedge-bone outer-wedge"
            id="outer-wedge-bone"
          />
          <path
            d="M63.69,288.56A186.49,186.49,0,0,1,134.4,38.18C162.87,21.74,190.28,14,222.64,13.25V120.19a81.31,81.31,0,0,0-66.82,115.18Z"
            style="fill: #38a947"
            class="inner-wedge-disease inner-wedge"
            id="inner-wedge-disease"
          />
          <path
            d="M217.64,18.42v97.29a86.31,86.31,0,0,0-68.17,117.55L65.7,281.63A181.5,181.5,0,0,1,136.9,42.51c26.19-15.13,51.46-22.71,80.74-24.09m10-10.23c-35.22,0-65.25,8-95.74,25.66-91.59,52.87-123,170-70.09,261.57L162.4,237.34a76.29,76.29,0,0,1,65.24-112.42V8.19Z"
            style="fill: #389d45"
            class="outer-wedge-disease outer-wedge"
            id="outer-wedge-disease"
          />
          <path
            d="M303.34,235.35a81.29,81.29,0,0,0-66.79-115.16V13.26C337.08,15.91,418,98.52,418,199.68c0,32.88-7,60.51-22.53,88.89Z"
            style="fill: #ececec"
            class="inner-wedge-mortality inner-wedge"
            id="inner-wedge-mortality"
          />
          <path
            d="M241.55,18.46A181.51,181.51,0,0,1,413,199.68c0,30.24-6.07,55.92-19.52,82l-83.83-48.4a86.3,86.3,0,0,0-18.37-92.36,85.77,85.77,0,0,0-49.77-25.17V18.46m-10-10.27V124.92a76.28,76.28,0,0,1,65.21,112.41l100.62,58.09C415,264.93,423,234.9,423,199.68,423,93.92,337.31,8.19,231.55,8.19Z"
            style="fill: #e4e4e4"
            class="outer-wedge-mortality outer-wedge"
            id="outer-wedge-mortality"
          />
          <path
            d="M144.94,411.8A35.78,35.78,0,1,1,180.72,376,35.83,35.83,0,0,1,144.94,411.8Z"
            style="fill: #bfb8ff"
            id="hoverable-bone"
            class="hoverable"
            @mouseenter=${this._handleBone}
            @click=${this._handleBone}
          />
          <path
            d="M144.94,341.74A34.28,34.28,0,1,1,110.66,376a34.28,34.28,0,0,1,34.28-34.28m0-3A37.28,37.28,0,1,0,182.22,376a37.32,37.32,0,0,0-37.28-37.28Z"
            style="fill: #fff"
          />
          <path
            d="M308.12,411.8A35.78,35.78,0,1,1,343.9,376,35.83,35.83,0,0,1,308.12,411.8Z"
            style="fill: #bfb8ff"
            id="hoverable-bone-glass"
            class="hoverable"
            @mouseenter=${this._handleBoneGlass}
            @click=${this._handleBoneGlass}
          />
          <path
            d="M308.12,341.74A34.28,34.28,0,1,1,273.84,376a34.28,34.28,0,0,1,34.28-34.28m0-3A37.28,37.28,0,1,0,345.4,376a37.32,37.32,0,0,0-37.28-37.28Z"
            style="fill: #fff"
          />
          <path
            d="M335.08,372.65l-.23.2A1.78,1.78,0,0,1,335.08,372.65Z"
            style="fill: #b9bbbd"
          />
          <path
            d="M292.55,392.05a1.33,1.33,0,0,1-.2-1.62l0,0a1.32,1.32,0,0,0,1.88,1.85l0,0A1.33,1.33,0,0,1,292.55,392.05Z"
            style="fill: #231f20; opacity: 0.2"
          />
          <path
            d="M307.36,378.67a11.06,11.06,0,1,0-1.43-15.57A11.06,11.06,0,0,0,307.36,378.67ZM321.22,362a10.35,10.35,0,1,1-14.58,1.35A10.36,10.36,0,0,1,321.22,362Z"
            style="opacity: 0.2"
          />
          <path
            d="M325.48,373.73a11.74,11.74,0,1,0-14.62,7.87A11.74,11.74,0,0,0,325.48,373.73Zm-21.57-6.47A11.05,11.05,0,1,1,311.32,381,11.05,11.05,0,0,1,303.91,367.26Z"
            style="opacity: 0.2"
          />
          <path
            d="M322.54,362.06a11.74,11.74,0,1,0,0,16.6A11.73,11.73,0,0,0,322.54,362.06ZM306.61,378a11.06,11.06,0,1,1,15.64,0A11.06,11.06,0,0,1,306.61,378Z"
            style="opacity: 0.2"
          />
          <path
            d="M293.29,389.39l9.32-9.32a1.63,1.63,0,0,1,1.12-.46c-.06-.21,0-.29,0-.29l.14-.14a1.61,1.61,0,0,0-1.84.31l-9.32,9.32a1.61,1.61,0,0,0,0,2.28l.58.58A1.61,1.61,0,0,1,293.29,389.39Z"
            style="fill: #231f20; opacity: 0.2"
          />
          <path
            d="M305.46,380.69l-.18.17a.15.15,0,0,1-.13.05,1.78,1.78,0,0,1-.52,1.18l-9.32,9.32a1.5,1.5,0,0,1-2.1.18l.49.49a1.5,1.5,0,0,0,2.1-.18l9.32-9.32A1.57,1.57,0,0,0,305.46,380.69Z"
            style="fill: #231f20; opacity: 0.2"
          />
          <path
            d="M304.26,380.35c-.75-.76-.53-1-.53-1l.14-.14a1.6,1.6,0,0,0-1.85.3l-9.33,9.32a1.63,1.63,0,0,0,0,2.28l.59.58C292.71,391.1,301.16,382.54,304.26,380.35Z"
            style="fill: #231f20; opacity: 0.2"
          />
          <path
            d="M305.54,379.05c-.48-.48-.74-.8-.74-.8l-.23.23a10,10,0,0,0,.74.81,6.75,6.75,0,0,0,.81.74l.23-.24A6.52,6.52,0,0,1,305.54,379.05Z"
            style="fill: #231f20; opacity: 0.2"
          />
          <g style="opacity: 0.2">
            <path
              d="M304,379.55l1.07-1.07-.22-.25-1.09,1.09s-.24.24.54,1l.12.12C303.76,379.77,304,379.55,304,379.55Z"
              style="fill: #231f20"
            />
          </g>
          <path
            d="M323.3,379a12.54,12.54,0,1,0-17.74,0c-.22-.22-.4-.41-.52-.55h0l-.22-.25,0,0-.13.13-.1.1-.7.7a1.6,1.6,0,0,0-1.85.3l-9.33,9.32a1.62,1.62,0,0,0-.39,1.64,1.32,1.32,0,0,0,1.86,1.85,1.62,1.62,0,0,0,1.64-.39l9.32-9.32a1.62,1.62,0,0,0,.3-1.86l.7-.69h0l.23-.24h0l0,0a6.52,6.52,0,0,1-.81-.74h0A12.54,12.54,0,0,0,323.3,379Zm-16.69-1a11.06,11.06,0,1,1,15.64,0A11.06,11.06,0,0,1,306.61,378Z"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M305.42,380.72l-.14.14s-.24.24-1-.53-.54-1-.54-1l.14-.14a1.6,1.6,0,0,0-1.85.3l-9.33,9.32a1.63,1.63,0,0,0,0,2.28l.83.82a1.61,1.61,0,0,0,2.28,0l9.32-9.32A1.62,1.62,0,0,0,305.42,380.72Z"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M323.3,361.3a12.54,12.54,0,1,0,0,17.73A12.54,12.54,0,0,0,323.3,361.3ZM306.61,378a11.06,11.06,0,1,1,15.64,0A11.06,11.06,0,0,1,306.61,378Z"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M293.52,391.9l-.83-.82a1.78,1.78,0,0,1-.39-.64,1.32,1.32,0,0,0,1.86,1.85A1.54,1.54,0,0,1,293.52,391.9Z"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M119.31,73.07a35.78,35.78,0,1,1,30.95-17.79A35.79,35.79,0,0,1,119.31,73.07Z"
            style="fill: #bfb8ff"
            id="hoverable-disease"
            class="hoverable"
            @mouseenter=${this._handleDisease}
            @click=${this._handleDisease}
          />
          <path
            d="M119.37,3a34.29,34.29,0,0,1-.06,68.57A34.29,34.29,0,0,1,119.37,3m0-3V0h0A37.41,37.41,0,0,0,87.12,18.54a37.28,37.28,0,0,0,32.19,56A37.29,37.29,0,0,0,119.37,0Z"
            style="fill: #fff"
          />
          <path
            d="M37.24,214.1a35.78,35.78,0,1,1,31-17.78A35.82,35.82,0,0,1,37.24,214.1Z"
            style="fill: #8cf58c"
            id="hoverable-disease-glass"
            class="hoverable"
            @mouseenter=${this._handleDiseaseGlass}
            @click=${this._handleDiseaseGlass}
          />
          <path
            d="M37.3,144a34.28,34.28,0,1,1-29.66,17A34.15,34.15,0,0,1,37.3,144m0-3v0h0a37.29,37.29,0,1,0,32.19,56,37.28,37.28,0,0,0-32.18-56Z"
            style="fill: #fff"
          />
          <path
            d="M423.92,220a35.79,35.79,0,1,1,31-53.63,35.8,35.8,0,0,1-31,53.63Z"
            style="fill: #bfb8ff"
            id="hoverable-mortality-glass"
            class="hoverable"
            @mouseenter=${this._handleMortalityGlass}
            @click=${this._handleMortalityGlass}
          />
          <path
            d="M423.86,150a34.28,34.28,0,1,1-17.07,4.57A34.25,34.25,0,0,1,423.86,150m0-3a37.28,37.28,0,1,0,32.34,18.69A37.29,37.29,0,0,0,423.86,147Z"
            style="fill: #fff"
          />
          <path
            d="M342.54,78.6a35.78,35.78,0,1,1,17.81-4.77A35.88,35.88,0,0,1,342.54,78.6Z"
            style="fill: #bfb8ff"
            id="hoverable-mortality"
            class="hoverable"
            @mouseenter=${this._handleMortality}
            @click=${this._handleMortality}
          />
          <path
            d="M342.48,8.53a34.3,34.3,0,1,1-17.07,4.58,34.27,34.27,0,0,1,17.07-4.58m0-3h0a37.29,37.29,0,1,0,32.34,18.7,37.2,37.2,0,0,0-32.34-18.7Z"
            style="fill: #fff"
          />
          <path
            d="M163.6,367.86a4.43,4.43,0,0,0-3.48,4.5,3.56,3.56,0,0,1,2.74,1.18,5.2,5.2,0,0,0,1,1.08,1.78,1.78,0,0,0,1.41.17,2.74,2.74,0,0,0,1.22-.76,2.58,2.58,0,0,0,.77-1.75,1.55,1.55,0,0,0-1.08-1.47c-.69-.17-1.38.27-2.09.27a1.54,1.54,0,0,1-1.4-.86,1.22,1.22,0,0,1,.48-1.52c.12-.06.25-.11.37-.18a.48.48,0,0,0,.25-.31A.36.36,0,0,0,163.6,367.86Z"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M166.06,370.73a1,1,0,0,0-1,.36,2.43,2.43,0,0,0-.45,1,5.51,5.51,0,0,1-.32,1.07,1.26,1.26,0,0,1-.83.7c-.08,0-.19.05-.19.13a.12.12,0,0,0,0,.08,1.77,1.77,0,0,0,1.64.69,2.69,2.69,0,0,0,1.61-.86,2.62,2.62,0,0,0,.69-1.18,1.52,1.52,0,0,0-1.19-2Z"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M123.51,377.23a1.18,1.18,0,0,0-.73,1.27,1.81,1.81,0,0,0,.87,1.27,3.94,3.94,0,0,1,.93.61,2.08,2.08,0,0,1,.3,1.61,2.72,2.72,0,0,0,.16,1.65,1.31,1.31,0,0,0,1.78.42,2,2,0,0,1-1.95.48,2.07,2.07,0,0,1-1.39-1.46,13.13,13.13,0,0,1-.1-1.54,2.82,2.82,0,0,0-.39-1.13,6.13,6.13,0,0,1-.66-1,1.6,1.6,0,0,1,.09-1.35A1.72,1.72,0,0,1,123.51,377.23Z"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M166.32,374.19a3.56,3.56,0,0,1-3.12-1.46,4,4,0,0,0-4.61-1.31c-1.15.48-16.84,6.76-20,7.21a54.33,54.33,0,0,0-8.47,2.28,6.33,6.33,0,0,0-2.37,1,3.38,3.38,0,0,0-1,2.14,12.19,12.19,0,0,1,3.33-2c1.55-.49,9.58-2.56,9.58-2.56a87,87,0,0,0,11.56-4.07,40.79,40.79,0,0,1,8.64-3,3,3,0,0,1,2.48.69c1.06,1,1.18,1.83,2.33,1.74a2.16,2.16,0,0,0,1.58-.68"
            style="fill: #231f20; opacity: 0.2"
          />
          <path
            d="M146.26,373.78a70.26,70.26,0,0,0,10.12-4.18,26.22,26.22,0,0,1,3.16-1.52,7.07,7.07,0,0,1,3.43-.45,1.16,1.16,0,0,1,.62.24.45.45,0,0,1,.09.59,1.32,1.32,0,0,0-1.1,1.27,1.4,1.4,0,0,0,1.12,1.35c.81.13,1.61-.48,2.41-.31a1.61,1.61,0,0,1,1.15,1.73,2.76,2.76,0,0,1-1.17,1.86,2.11,2.11,0,0,1-1.89.47c-.79-.27-1.17-1.15-1.79-1.7a3.27,3.27,0,0,0-2.48-.69,10,10,0,0,0-2.55.71L144.64,378c-3.62,1.23-7.31,2.29-11,3.16a15.24,15.24,0,0,0-5.57,2c-.82.6-1.61,1.41-2.62,1.45a2,2,0,0,1-2-1.57c-.11-.57.05-1.17-.08-1.74-.22-1-1.24-1.69-1.17-2.68a1.82,1.82,0,0,1,1.62-1.48,6.93,6.93,0,0,1,2.35.22c3.54.62,10.65-.94,10.65-.94S143.93,374.55,146.26,373.78Z"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <g class="disease-text text">
            <path
              d="M109.84,197.88a5.66,5.66,0,0,1-2.33,2.22,6.42,6.42,0,0,1-3.34.65l-5.39-.29a6.29,6.29,0,0,1-3.21-1A5.67,5.67,0,0,1,93.51,197a7.64,7.64,0,0,1-.58-3.55,8,8,0,0,1,.93-3.46,5.65,5.65,0,0,1,2.2-2.24,5.73,5.73,0,0,1,3.13-.66.25.25,0,0,1,.2.1.31.31,0,0,1,.06.21l0,3.56c0,.2-.11.29-.29.28a2.55,2.55,0,0,0-1.91.6,2.78,2.78,0,0,0-.19,3.7,2.56,2.56,0,0,0,1.82.8l5.66.31a2.51,2.51,0,0,0,1.89-.6,2.49,2.49,0,0,0,.8-1.8,2.41,2.41,0,0,0-2.41-2.69c-.18,0-.26-.12-.25-.32l.37-3.53a.3.3,0,0,1,.08-.21.29.29,0,0,1,.18-.08,5.82,5.82,0,0,1,3.08,1,5.54,5.54,0,0,1,2,2.46,7.8,7.8,0,0,1,.54,3.55A7.61,7.61,0,0,1,109.84,197.88Z"
              style="fill: #fff"
            />
            <path
              d="M112,180l-17.56,1.65h-.1c-.17,0-.23-.14-.2-.32l.75-3.75a.34.34,0,0,1,.31-.3l11.72-.6a.08.08,0,0,0,.09-.06s0-.06-.06-.08l-10.61-5a.33.33,0,0,1-.17-.4l.73-3.67a.26.26,0,0,1,.14-.2.25.25,0,0,1,.25,0l15.58,8.32a.32.32,0,0,1,.18.37l-.74,3.73A.32.32,0,0,1,112,180Z"
              style="fill: #fff"
            />
            <path
              d="M117.25,160.52a.3.3,0,0,1-.23,0l-15.55-6.6a.3.3,0,0,1-.16-.17.24.24,0,0,1,0-.23l2.49-5.87a8.39,8.39,0,0,1,2-2.91,5.42,5.42,0,0,1,2.68-1.39,5.14,5.14,0,0,1,3,.37l6,2.56a5.1,5.1,0,0,1,2.32,1.88,5.31,5.31,0,0,1,.86,2.89,8.15,8.15,0,0,1-.72,3.44l-2.49,5.87A.3.3,0,0,1,117.25,160.52Zm-1.55-5.21,1-2.37a2.07,2.07,0,0,0,0-1.77,2.93,2.93,0,0,0-1.51-1.35l-4.74-2a2.81,2.81,0,0,0-2-.16,2.11,2.11,0,0,0-1.3,1.25l-1,2.35a.12.12,0,0,0,.07.17l9.34,4A.11.11,0,0,0,115.7,155.31Z"
              style="fill: #fff"
            />
            <path
              d="M124.43,144.83a.27.27,0,0,1-.23,0l-14.75-8.24a.31.31,0,0,1-.14-.18.26.26,0,0,1,0-.23l1.73-3.1a.33.33,0,0,1,.19-.14.25.25,0,0,1,.22,0l14.76,8.24a.28.28,0,0,1,.14.18.31.31,0,0,1,0,.23l-1.73,3.1A.28.28,0,0,1,124.43,144.83Z"
              style="fill: #fff"
            />
            <path
              d="M129.79,135.13a5.29,5.29,0,0,1-2.92.88,5.06,5.06,0,0,1-2.83-.95l-.39-.27a.25.25,0,0,1-.12-.19.28.28,0,0,1,0-.22l2-2.86a.34.34,0,0,1,.2-.13.34.34,0,0,1,.22.05l.25.17a1.74,1.74,0,0,0,1.65.14,3.63,3.63,0,0,0,1.77-1.48,2.35,2.35,0,0,0,.54-1.6,1.49,1.49,0,0,0-.61-1.06,1.12,1.12,0,0,0-.85-.21,2.68,2.68,0,0,0-.9.39c-.32.21-.79.54-1.41,1a1.85,1.85,0,0,0-.27.19,1.63,1.63,0,0,1-.22.17,20.53,20.53,0,0,1-2.55,1.68,6.25,6.25,0,0,1-2.56.72,4.26,4.26,0,0,1-2.7-.84,4.55,4.55,0,0,1-1.76-2.21,5.16,5.16,0,0,1-.18-2.88,7.94,7.94,0,0,1,1.35-3,8.19,8.19,0,0,1,2.54-2.45,5.67,5.67,0,0,1,3-.86,5,5,0,0,1,2.9,1l.29.19a.34.34,0,0,1,.13.2.34.34,0,0,1,0,.22l-2,2.86a.26.26,0,0,1-.19.12.27.27,0,0,1-.23,0l-.14-.1a2,2,0,0,0-1.72-.24,3.05,3.05,0,0,0-1.73,1.32,2.55,2.55,0,0,0-.54,1.48,1.41,1.41,0,0,0,1.56,1.33,3.51,3.51,0,0,0,1.17-.51c.45-.29,1.1-.75,2-1.4s1.8-1.28,2.41-1.64a5.41,5.41,0,0,1,2.25-.68,3.94,3.94,0,0,1,2.68.81,4.7,4.7,0,0,1,1.83,2.27,5.34,5.34,0,0,1,.18,2.93,8.78,8.78,0,0,1-1.45,3.21A9.12,9.12,0,0,1,129.79,135.13Z"
              style="fill: #fff"
            />
            <path
              d="M136.57,105.54a.32.32,0,0,1-.08.22l-5.35,5.74c-.06.06,0,.12,0,.18l2.25,2.09a.1.1,0,0,0,.17,0l3.43-3.68a.29.29,0,0,1,.42,0l2.14,2a.29.29,0,0,1,0,.42l-3.43,3.68c-.06.06-.05.12,0,.18l2.41,2.24a.11.11,0,0,0,.18,0l5.35-5.74a.26.26,0,0,1,.21-.1.28.28,0,0,1,.21.08l2.16,2a.3.3,0,0,1,.1.21.32.32,0,0,1-.08.21l-8.06,8.66a.29.29,0,0,1-.21.09.27.27,0,0,1-.22-.08l-12.36-11.52a.3.3,0,0,1-.1-.21.32.32,0,0,1,.08-.21l8.06-8.65a.3.3,0,0,1,.21-.1.29.29,0,0,1,.22.08l2.16,2A.29.29,0,0,1,136.57,105.54Z"
              style="fill: #fff"
            />
            <path
              d="M158,105.42l-1.89-1.34a.15.15,0,0,0-.16,0l-4.46,3.56s0,.08,0,.15l.88,2.15a.33.33,0,0,1-.12.41l-3,2.39a.31.31,0,0,1-.23.07.3.3,0,0,1-.19-.19l-6.35-16.55a.31.31,0,0,1,.1-.4l3.69-2.94a.31.31,0,0,1,.41,0l14.74,9.86a.24.24,0,0,1,.1.08c.09.12.07.24-.08.35l-3,2.38A.32.32,0,0,1,158,105.42Zm-7.74-.89,2.91-2.33c.08-.06.08-.12,0-.18l-5.49-3.83c-.06,0-.1,0-.12,0a.13.13,0,0,0,0,.12l2.54,6.19C150.16,104.56,150.21,104.58,150.28,104.53Z"
              style="fill: #fff"
            />
            <path
              d="M165.77,99.83a5.26,5.26,0,0,1-3-.43,5,5,0,0,1-2.18-2l-.24-.41a.31.31,0,0,1,0-.23.25.25,0,0,1,.14-.18l3-1.76a.27.27,0,0,1,.23,0,.28.28,0,0,1,.18.14l.15.26a1.77,1.77,0,0,0,1.44.82,3.69,3.69,0,0,0,2.23-.6,2.34,2.34,0,0,0,1.16-1.24,1.44,1.44,0,0,0-.11-1.21,1.06,1.06,0,0,0-.68-.54,2.67,2.67,0,0,0-1,0c-.37.06-.94.16-1.7.32a1.55,1.55,0,0,0-.31.06l-.28.06a20,20,0,0,1-3,.46,6.1,6.1,0,0,1-2.63-.43,4.22,4.22,0,0,1-2.1-1.88,4.68,4.68,0,0,1-.68-2.75,5.2,5.2,0,0,1,1.05-2.69,8.17,8.17,0,0,1,2.5-2.2,8.3,8.3,0,0,1,3.34-1.16,5.68,5.68,0,0,1,3.08.48,5.13,5.13,0,0,1,2.24,2.07l.17.31a.25.25,0,0,1,0,.22.33.33,0,0,1-.14.19l-3,1.76a.27.27,0,0,1-.23,0,.31.31,0,0,1-.19-.13l-.08-.16a2,2,0,0,0-1.46-.94,3.14,3.14,0,0,0-2.13.47,2.58,2.58,0,0,0-1.11,1.12,1.3,1.3,0,0,0,.1,1.25,1.23,1.23,0,0,0,.76.61,3.31,3.31,0,0,0,1.28,0c.53-.07,1.32-.22,2.36-.45q1.81-.37,2.88-.48a5.48,5.48,0,0,1,2.33.33,3.92,3.92,0,0,1,2.09,1.86,4.71,4.71,0,0,1,.72,2.83,5.32,5.32,0,0,1-1.08,2.73,8.59,8.59,0,0,1-2.66,2.31A9.09,9.09,0,0,1,165.77,99.83Z"
              style="fill: #fff"
            />
            <path
              d="M184.14,75.73a.28.28,0,0,1-.16.16l-7.25,3a.11.11,0,0,0-.07.16l1.19,2.84A.11.11,0,0,0,178,82L182.65,80a.31.31,0,0,1,.23,0,.3.3,0,0,1,.16.17l1.13,2.7a.3.3,0,0,1,0,.23.31.31,0,0,1-.16.16l-4.64,1.93a.11.11,0,0,0-.07.16l1.27,3a.11.11,0,0,0,.16.07l7.25-3a.31.31,0,0,1,.23,0,.28.28,0,0,1,.16.16l1.14,2.72a.3.3,0,0,1,0,.23.31.31,0,0,1-.17.17l-10.91,4.54a.27.27,0,0,1-.23,0,.3.3,0,0,1-.16-.17l-6.5-15.6a.26.26,0,0,1,0-.23.33.33,0,0,1,.17-.16l10.91-4.55a.3.3,0,0,1,.23,0,.28.28,0,0,1,.16.16l1.14,2.73A.3.3,0,0,1,184.14,75.73Z"
              style="fill: #fff"
            />
          </g>
          <g class="mortality-text text">
            <path
              d="M303.15,85.82l3,1.81a.28.28,0,0,1,.14.18.27.27,0,0,1,0,.23l-8.66,14.5a.29.29,0,0,1-.19.14.31.31,0,0,1-.23,0l-3-1.82a.33.33,0,0,1-.14-.19.28.28,0,0,1,0-.22l5.16-8.63c0-.06,0-.1,0-.11s-.07,0-.13,0l-3.61,1.86a.36.36,0,0,1-.41,0l-1.52-.91a.36.36,0,0,1-.2-.35l-.08-4.1c0-.06,0-.1-.05-.11s-.06,0-.09.06L288,96.77a.3.3,0,0,1-.19.14.28.28,0,0,1-.22,0l-3.05-1.82a.33.33,0,0,1-.14-.19.28.28,0,0,1,0-.23l8.67-14.5a.28.28,0,0,1,.18-.14.31.31,0,0,1,.23,0l3,1.81a.39.39,0,0,1,.2.35l.19,6.46c0,.12,0,.14.13.08l5.73-2.92A.36.36,0,0,1,303.15,85.82Z"
              style="fill: #38a947"
            />
            <path
              d="M303.36,106.71a5.82,5.82,0,0,1-.38-3.29,6.71,6.71,0,0,1,1.53-3.18l3.19-3.85a6.63,6.63,0,0,1,2.81-2,5.92,5.92,0,0,1,3.29-.23,7.59,7.59,0,0,1,3.26,1.65,7.69,7.69,0,0,1,2.23,2.91,5.83,5.83,0,0,1,.39,3.29,6.52,6.52,0,0,1-1.49,3.13L315,108.94a6.82,6.82,0,0,1-2.84,2.1,5.82,5.82,0,0,1-3.31.22,8.19,8.19,0,0,1-5.49-4.55Zm6.47.81a2.89,2.89,0,0,0,1.89-1.13l3.31-4a2.93,2.93,0,0,0,.75-2.06,2.56,2.56,0,0,0-1-1.84,2.51,2.51,0,0,0-2-.62A2.87,2.87,0,0,0,310.93,99l-3.3,4a2.87,2.87,0,0,0-.76,2.07,2.54,2.54,0,0,0,1,1.82A2.58,2.58,0,0,0,309.83,107.52Z"
              style="fill: #38a947"
            />
            <path
              d="M320,123l3-6.65a.19.19,0,0,0,0-.18l-1.11-1.22a.1.1,0,0,0-.17,0l-4.87,4.39a.27.27,0,0,1-.21.07.25.25,0,0,1-.21-.1L314,116.65a.29.29,0,0,1-.07-.22.29.29,0,0,1,.09-.21l12.55-11.31a.28.28,0,0,1,.22-.08.3.3,0,0,1,.21.1l5,5.51a6,6,0,0,1,1.44,2.61,4.76,4.76,0,0,1-.12,2.72,5.86,5.86,0,0,1-1.65,2.41,5.07,5.07,0,0,1-2.7,1.33A4.74,4.74,0,0,1,326,119a.12.12,0,0,0-.18.06l-2.9,7a.26.26,0,0,1-.08.14c-.09.09-.2.07-.33-.07L320,123.39A.37.37,0,0,1,320,123Zm6.84-12.73-2.64,2.38a.11.11,0,0,0,0,.17l1.86,2.06a2.12,2.12,0,0,0,1.39.77,1.7,1.7,0,0,0,1.39-.48,1.82,1.82,0,0,0,.66-1.37,2.12,2.12,0,0,0-.62-1.46L327,110.26A.1.1,0,0,0,326.8,110.25Z"
              style="fill: #38a947"
            />
            <path
              d="M346.51,130.14a.31.31,0,0,1-.13.2L343.92,132a.29.29,0,0,1-.42-.08l-2.45-3.63a.1.1,0,0,0-.17,0l-11.19,7.55a.25.25,0,0,1-.22.05.31.31,0,0,1-.2-.13l-2-2.94a.31.31,0,0,1-.05-.23.31.31,0,0,1,.13-.19l11.19-7.55a.1.1,0,0,0,0-.17l-2.36-3.51a.28.28,0,0,1-.05-.22.29.29,0,0,1,.13-.19l2.46-1.67a.31.31,0,0,1,.23,0,.3.3,0,0,1,.19.12l7.27,10.78A.25.25,0,0,1,346.51,130.14Z"
              style="fill: #38a947"
            />
            <path
              d="M338.24,151.35l1.7-1.58a.13.13,0,0,0,0-.15l-2.54-5.11s-.07-.06-.14-.07l-2.28.41a.33.33,0,0,1-.38-.2l-1.7-3.43a.26.26,0,0,1,0-.24c0-.07.1-.11.22-.14l17.52-2.72a.3.3,0,0,1,.36.18l2.11,4.24a.33.33,0,0,1-.08.4L340.3,155.26a.25.25,0,0,1-.1.08c-.14.07-.25,0-.33-.14l-1.7-3.43A.32.32,0,0,1,338.24,151.35Zm2.5-7.39,1.66,3.34c0,.09.1.1.18,0l4.91-4.56c.05,0,.07-.08,0-.1a.1.1,0,0,0-.11,0l-6.59,1.18Q340.7,143.86,340.74,144Z"
              style="fill: #38a947"
            />
            <path
              d="M341.29,158.79a.28.28,0,0,1,.17-.15l16.07-5.23a.3.3,0,0,1,.23,0,.35.35,0,0,1,.15.17L359,157a.3.3,0,0,1,0,.23.34.34,0,0,1-.18.15L346,161.54a.12.12,0,0,0-.08.16l2.47,7.59a.24.24,0,0,1,0,.22.23.23,0,0,1-.17.15l-2.81.92a.31.31,0,0,1-.23,0,.29.29,0,0,1-.14-.17L341.27,159A.27.27,0,0,1,341.29,158.79Z"
              style="fill: #38a947"
            />
            <path
              d="M345.87,174.28a.28.28,0,0,1,.19-.13l16.53-3.54a.29.29,0,0,1,.22,0,.28.28,0,0,1,.13.19l.75,3.47a.37.37,0,0,1,0,.23.31.31,0,0,1-.19.13l-16.53,3.53a.27.27,0,0,1-.23,0,.27.27,0,0,1-.13-.19l-.74-3.47A.29.29,0,0,1,345.87,174.28Z"
              style="fill: #38a947"
            />
            <path
              d="M366.19,193.4a.31.31,0,0,1-.2.11l-3,.31a.26.26,0,0,1-.22-.07.26.26,0,0,1-.11-.2l-.46-4.35a.11.11,0,0,0-.14-.11l-13.43,1.42a.3.3,0,0,1-.22-.06.28.28,0,0,1-.1-.21l-.38-3.53a.27.27,0,0,1,.07-.22.31.31,0,0,1,.2-.11L361.66,185c.09,0,.12-.05.11-.13l-.44-4.21a.3.3,0,0,1,.06-.22.33.33,0,0,1,.21-.11l2.95-.31a.28.28,0,0,1,.23.07.25.25,0,0,1,.1.2l1.37,12.93A.3.3,0,0,1,366.19,193.4Z"
              style="fill: #38a947"
            />
            <path
              d="M349,203.52a.35.35,0,0,1,.22-.08l5.92.23.15,0,10.91-4.72a.5.5,0,0,1,.15-.05c.14,0,.2.1.19.29l-.14,3.84a.36.36,0,0,1-.24.34l-6.42,2.49c-.1,0-.11.1,0,.15l6.22,3a.36.36,0,0,1,.21.36l-.14,3.88a.29.29,0,0,1-.1.23.27.27,0,0,1-.26,0l-10.53-5.6a.26.26,0,0,0-.14,0l-5.92-.23a.26.26,0,0,1-.21-.09.25.25,0,0,1-.08-.22l.13-3.52A.29.29,0,0,1,349,203.52Z"
              style="fill: #38a947"
            />
          </g>
          <g class="bone-text text">
            <path
              d="M152.8,303.86a4.18,4.18,0,0,1-.74,4.55,4.26,4.26,0,0,1-3.68,1.82,7.69,7.69,0,0,1-4.29-1.88l-5.18-4.17a.27.27,0,0,1-.11-.2.29.29,0,0,1,.06-.22l10.59-13.17a.27.27,0,0,1,.2-.11.28.28,0,0,1,.22.06l5,4a7.77,7.77,0,0,1,2.87,3.79,4.29,4.29,0,0,1-1.11,3.88,3.71,3.71,0,0,1-3.77,1.5C152.78,303.72,152.75,303.76,152.8,303.86Zm-5,2.31a1.61,1.61,0,0,0,1.26-.7,1.64,1.64,0,0,0,.41-1.36,2.39,2.39,0,0,0-.93-1.34l-2.08-1.67c-.07-.05-.13-.05-.18,0l-2.08,2.59c-.06.06,0,.12,0,.18l2.08,1.67A2.33,2.33,0,0,0,147.83,306.17Zm2.74-10.35-2,2.45a.11.11,0,0,0,0,.18l1.93,1.55a2.51,2.51,0,0,0,1.5.65,1.5,1.5,0,0,0,1.2-.62,1.54,1.54,0,0,0,.37-1.34,2.43,2.43,0,0,0-.94-1.34l-1.93-1.55C150.68,295.75,150.62,295.75,150.57,295.82Z"
              style="fill: #38a947"
            />
            <path
              d="M156.69,316.72a5.84,5.84,0,0,1-.88-3.19,6.77,6.77,0,0,1,1-3.38l2.56-4.29a6.4,6.4,0,0,1,2.45-2.45,5.82,5.82,0,0,1,3.21-.74,8.24,8.24,0,0,1,6.13,3.66,5.85,5.85,0,0,1,.9,3.18,6.49,6.49,0,0,1-1,3.32l-2.56,4.3a6.81,6.81,0,0,1-2.49,2.51,5.79,5.79,0,0,1-3.23.73,8.26,8.26,0,0,1-6.13-3.65Zm6.52-.2a2.89,2.89,0,0,0,1.7-1.41l2.65-4.44a2.89,2.89,0,0,0,.42-2.15,2.74,2.74,0,0,0-3.31-2,2.86,2.86,0,0,0-1.68,1.39l-2.65,4.45a2.84,2.84,0,0,0-.43,2.16,2.5,2.5,0,0,0,1.24,1.64A2.56,2.56,0,0,0,163.21,316.52Z"
              style="fill: #38a947"
            />
            <path
              d="M186.58,312.93a.3.3,0,0,1,.23,0l3.28,1.36a.31.31,0,0,1,.16.16.31.31,0,0,1,0,.23l-6.47,15.62a.28.28,0,0,1-.16.16.31.31,0,0,1-.23,0l-3.14-1.3a.37.37,0,0,1-.25-.32l-1.66-11c0-.06,0-.09-.07-.1s-.06,0-.08.09l-3.58,8.69a.25.25,0,0,1-.16.16.27.27,0,0,1-.23,0l-3.28-1.36a.25.25,0,0,1-.16-.16.3.3,0,0,1,0-.23l6.46-15.61a.28.28,0,0,1,.16-.16.24.24,0,0,1,.23,0l3.17,1.31a.36.36,0,0,1,.25.31l1.64,11c0,.05,0,.09.07.09s.06,0,.09-.08l3.56-8.68A.3.3,0,0,1,186.58,312.93Z"
              style="fill: #38a947"
            />
            <path
              d="M205,321.93a.31.31,0,0,1-.23,0l-7.6-2a.12.12,0,0,0-.16.09l-.76,3a.11.11,0,0,0,.09.15l4.87,1.25a.28.28,0,0,1,.18.14.31.31,0,0,1,0,.23l-.73,2.83a.27.27,0,0,1-.13.18.28.28,0,0,1-.23,0l-4.87-1.26a.11.11,0,0,0-.15.09l-.82,3.2a.11.11,0,0,0,.09.15l7.6,2a.25.25,0,0,1,.18.14.25.25,0,0,1,0,.22l-.74,2.86a.25.25,0,0,1-.14.18.25.25,0,0,1-.22,0l-11.46-3a.25.25,0,0,1-.18-.14.28.28,0,0,1,0-.22l4.21-16.37a.31.31,0,0,1,.13-.19.31.31,0,0,1,.23,0l11.45,2.95a.29.29,0,0,1,.19.13.31.31,0,0,1,0,.23l-.73,2.86A.32.32,0,0,1,205,321.93Z"
              style="fill: #38a947"
            />
            <path
              d="M215.09,337.56a.29.29,0,0,1-.08-.22l1-16.87a.23.23,0,0,1,.1-.2.28.28,0,0,1,.21-.08l6.37.37a8.36,8.36,0,0,1,3.4.88,5.3,5.3,0,0,1,2.21,2.05,5.15,5.15,0,0,1,.66,2.92l-.38,6.54a5.21,5.21,0,0,1-1,2.82,5.33,5.33,0,0,1-2.44,1.79,8.25,8.25,0,0,1-3.48.47l-6.37-.37A.26.26,0,0,1,215.09,337.56Zm4.38-3.21,2.57.15a2,2,0,0,0,1.66-.62,2.84,2.84,0,0,0,.76-1.87l.3-5.14a2.79,2.79,0,0,0-.52-1.95,2.14,2.14,0,0,0-1.62-.81l-2.55-.14c-.08,0-.12,0-.13.11l-.59,10.14A.12.12,0,0,0,219.47,334.35Z"
              style="fill: #38a947"
            />
            <path
              d="M233.86,338.12a.29.29,0,0,1-.09-.21L233,321a.33.33,0,0,1,.08-.22.35.35,0,0,1,.21-.1l3.55-.16a.32.32,0,0,1,.21.08.3.3,0,0,1,.1.21l.76,16.88a.28.28,0,0,1-.07.22.35.35,0,0,1-.21.1l-3.55.16A.35.35,0,0,1,233.86,338.12Z"
              style="fill: #38a947"
            />
            <path
              d="M246.4,336.82a5.37,5.37,0,0,1-2.63-1.53,5,5,0,0,1-1.25-2.71l-.07-.47a.29.29,0,0,1,.25-.34l3.44-.51a.25.25,0,0,1,.22.05.28.28,0,0,1,.12.2l0,.3a1.8,1.8,0,0,0,1,1.3,3.65,3.65,0,0,0,2.29.27,2.3,2.3,0,0,0,1.54-.71,1.44,1.44,0,0,0,.36-1.16,1.14,1.14,0,0,0-.43-.76,2.45,2.45,0,0,0-.91-.39c-.37-.09-.93-.21-1.69-.35a1.8,1.8,0,0,0-.32-.06l-.28-.05a19.24,19.24,0,0,1-3-.71,6,6,0,0,1-2.28-1.38,4.2,4.2,0,0,1-1.24-2.53,4.56,4.56,0,0,1,.41-2.8,5.14,5.14,0,0,1,2-2.1,7.91,7.91,0,0,1,3.15-1.1,8.28,8.28,0,0,1,3.53.18,5.73,5.73,0,0,1,2.67,1.59,5.08,5.08,0,0,1,1.3,2.77l.05.35a.34.34,0,0,1-.05.22.32.32,0,0,1-.2.12L251,325a.29.29,0,0,1-.22-.06.26.26,0,0,1-.12-.19l0-.18a2,2,0,0,0-1-1.42,3,3,0,0,0-2.15-.36,2.6,2.6,0,0,0-1.45.62,1.31,1.31,0,0,0-.38,1.2,1.25,1.25,0,0,0,.48.85,3.36,3.36,0,0,0,1.18.5c.51.14,1.3.3,2.35.48a28.74,28.74,0,0,1,2.85.63,5.37,5.37,0,0,1,2,1.18,4,4,0,0,1,1.24,2.5,4.76,4.76,0,0,1-.4,2.9,5.34,5.34,0,0,1-2,2.13,8.63,8.63,0,0,1-3.33,1.14A9.25,9.25,0,0,1,246.4,336.82Z"
              style="fill: #38a947"
            />
            <path
              d="M270.08,317.58a.28.28,0,0,1-.18.14l-7.54,2.19a.12.12,0,0,0-.09.16l.86,2.95a.12.12,0,0,0,.16.09l4.82-1.41a.31.31,0,0,1,.23,0,.28.28,0,0,1,.14.18l.82,2.81a.31.31,0,0,1,0,.23.28.28,0,0,1-.18.14l-4.83,1.4a.11.11,0,0,0-.08.16l.92,3.16a.11.11,0,0,0,.15.09l7.54-2.19a.3.3,0,0,1,.23,0,.28.28,0,0,1,.14.18l.82,2.84a.24.24,0,0,1,0,.22.3.3,0,0,1-.18.15l-11.36,3.3a.28.28,0,0,1-.22,0,.3.3,0,0,1-.15-.18L257.35,318a.24.24,0,0,1,0-.22.3.3,0,0,1,.18-.15l11.36-3.3a.31.31,0,0,1,.23,0,.28.28,0,0,1,.14.18l.82,2.83A.26.26,0,0,1,270.08,317.58Z"
              style="fill: #38a947"
            />
            <path
              d="M289.53,324.26,288,322.51c-.06-.05-.11-.06-.15,0l-5.19,2.36c-.05,0-.07.07-.07.15l.33,2.29a.33.33,0,0,1-.22.37l-3.48,1.59a.29.29,0,0,1-.24,0c-.07,0-.11-.11-.13-.23l-2.14-17.59a.33.33,0,0,1,.2-.37l4.3-2a.33.33,0,0,1,.4.1l11.89,13.15a.27.27,0,0,1,.08.1c.06.14,0,.25-.16.32L290,324.35A.32.32,0,0,1,289.53,324.26Zm-7.3-2.74,3.39-1.55q.13-.06,0-.18l-4.39-5.06c0-.05-.08-.06-.11,0a.14.14,0,0,0,0,.11l1,6.62C282.1,321.52,282.15,321.55,282.23,321.52Z"
              style="fill: #38a947"
            />
            <path
              d="M299.53,318.61a5.38,5.38,0,0,1-3-.34,4.91,4.91,0,0,1-2.23-2l-.26-.4a.31.31,0,0,1,0-.23.25.25,0,0,1,.14-.18l2.93-1.86a.27.27,0,0,1,.23,0,.31.31,0,0,1,.19.13l.16.26a1.76,1.76,0,0,0,1.46.77,3.64,3.64,0,0,0,2.21-.67,2.39,2.39,0,0,0,1.12-1.27,1.44,1.44,0,0,0-.14-1.21,1.12,1.12,0,0,0-.7-.52,2.35,2.35,0,0,0-1,0c-.37.07-.94.19-1.69.37l-.31.07a1.64,1.64,0,0,1-.28.07,18.35,18.35,0,0,1-3,.55,6.14,6.14,0,0,1-2.64-.34,4.22,4.22,0,0,1-2.15-1.82,4.58,4.58,0,0,1-.77-2.72,5.24,5.24,0,0,1,1-2.72,8.88,8.88,0,0,1,5.73-3.54,5.65,5.65,0,0,1,3.1.38,5,5,0,0,1,2.3,2l.19.3a.29.29,0,0,1,0,.22.27.27,0,0,1-.13.19L299,306a.31.31,0,0,1-.23,0,.31.31,0,0,1-.19-.13l-.09-.15a2,2,0,0,0-1.48-.9,3.11,3.11,0,0,0-2.12.54,2.56,2.56,0,0,0-1.07,1.15,1.33,1.33,0,0,0,.13,1.25,1.27,1.27,0,0,0,.79.58,3.23,3.23,0,0,0,1.28,0c.52-.08,1.31-.26,2.34-.52a27.85,27.85,0,0,1,2.87-.57,5.53,5.53,0,0,1,2.33.25,4,4,0,0,1,2.16,1.79,4.8,4.8,0,0,1,.79,2.81,5.23,5.23,0,0,1-1,2.77,8.6,8.6,0,0,1-2.59,2.39A9.14,9.14,0,0,1,299.53,318.61Z"
              style="fill: #38a947"
            />
            <path
              d="M313.43,291.46a.33.33,0,0,1-.11.2l-6,5a.11.11,0,0,0,0,.18l2,2.35a.11.11,0,0,0,.18,0l3.85-3.23a.29.29,0,0,1,.22-.07.27.27,0,0,1,.2.11l1.88,2.24a.29.29,0,0,1,.07.22.27.27,0,0,1-.11.2L311.7,302a.11.11,0,0,0,0,.18l2.12,2.53a.11.11,0,0,0,.17,0l6-5a.29.29,0,0,1,.22-.07.27.27,0,0,1,.2.11l1.9,2.26a.34.34,0,0,1,.07.22.31.31,0,0,1-.11.2l-9.07,7.6a.26.26,0,0,1-.21.06.28.28,0,0,1-.21-.1l-10.85-13a.24.24,0,0,1-.07-.21.29.29,0,0,1,.11-.21l9.06-7.59a.26.26,0,0,1,.22-.07.3.3,0,0,1,.2.1l1.9,2.27A.32.32,0,0,1,313.43,291.46Z"
              style="fill: #38a947"
            />
          </g>
          <path
            d="M116.86,19.36l1.1-.52s.72-.73,1-3.27l.09-1.86a1.37,1.37,0,0,1,1.34-.1l0,3.83s-.15.66.41.86a9.92,9.92,0,0,0,1.74.31,2.52,2.52,0,0,0,1.14-.51c.3-.35,2.21-3,2.21-3s1.2-.09,1.57.56l-1.61,3.12a1.67,1.67,0,0,0,0,.87c.11.42.77-.43,1.35-1.06s1.88-2.09,1.88-2.09a1.13,1.13,0,0,1,.93.77l-1.7,2s-.67,1-.39,1.67,1.19.18,1.52,2.94a7.65,7.65,0,0,1-.31,2.71L130,27a1.78,1.78,0,0,1,.36,2,3.87,3.87,0,0,1-.74,1,1.19,1.19,0,0,1,1.2.69,1.33,1.33,0,0,1-.13,1.32s.92,0,1.13.74a1.38,1.38,0,0,1-.82,1.68,1.29,1.29,0,0,1-1-.11,8.45,8.45,0,0,1,1.08,3.21l.25,2.41s.59-.14.56.63-.81,7.5-2.3,10.3a32.11,32.11,0,0,1-6.42,8.76c-2.92,2.67-3.83.89-5,.3s-6.62-4.16-8.21-5.91-4.11-3.84-2.86-8.16l.33-1.37a7,7,0,0,1-.57-4.88,20,20,0,0,1,2.13-5.49,33.47,33.47,0,0,0,2.13-4.86,11.21,11.21,0,0,0-.52-7.75A49.46,49.46,0,0,0,108,17a2.33,2.33,0,0,1,.93-1.86,6.15,6.15,0,0,1,1.92-1s1.06,1.8,1.92,3a3.58,3.58,0,0,0,1.06,1.13l1.19-1a1.2,1.2,0,0,1,1.32.48A2,2,0,0,1,116.86,19.36Z"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M115.4,17.68A.86.86,0,0,1,116,18a1.82,1.82,0,0,1,.29.72,1.18,1.18,0,0,1,0,.53.48.48,0,0,1-.35.35.59.59,0,0,1-.47-.23,1.86,1.86,0,0,1-.47-1,.85.85,0,0,1,.07-.5C115.18,17.76,115.23,17.68,115.4,17.68Z"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M129.62,27.38a.66.66,0,0,0-.25-.07,1.54,1.54,0,0,0-.92.2,2.08,2.08,0,0,0-.81.9,1.83,1.83,0,0,0-.25,1,1,1,0,0,0,.54.83,1.21,1.21,0,0,0,1-.1,2.17,2.17,0,0,0,1.1-2.25A.75.75,0,0,0,129.62,27.38Z"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M130.13,30.56a.48.48,0,0,0-.4-.06,1,1,0,0,0-.37.21,1.44,1.44,0,0,0-.41.47,1,1,0,0,0-.11.66.69.69,0,0,0,.58.55.81.81,0,0,0,.7-.35,1.28,1.28,0,0,0,.28-.81A1,1,0,0,0,130.13,30.56Z"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M131.28,32.56a.41.41,0,0,0-.37-.06.9.9,0,0,0-.36.19,1.38,1.38,0,0,0-.39.44.87.87,0,0,0-.1.61.63.63,0,0,0,.55.51.78.78,0,0,0,.67-.32,1.19,1.19,0,0,0,.27-.76A.87.87,0,0,0,131.28,32.56Z"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M116,30.12A10.27,10.27,0,0,1,114,26.6a4.63,4.63,0,0,1,.52-4.48,6,6,0,0,1,3-2.23,2,2,0,0,0,1-.78c.42-.61,1.13-3.79.59-5.22,0,0-.1,4-1.1,4.95l-.79.41a1.91,1.91,0,0,0-.73.65h0s-3.41,1.69-3.6,4.78,2.77,5.82,2.77,5.82l.43-.38"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M120,13.48l-.19,5s-.31.3.71.49a6.83,6.83,0,0,0,2.83.16c.43-.22,1.54-2.15,1.68-2.23a13,13,0,0,0,.88-1.82l-2.31,3.11a2.59,2.59,0,0,1-1.58.36l-1.21-.25s-.4.05-.41-1.22l0-3.47Z"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M127.38,15.49a15,15,0,0,1-1,1.62,4.91,4.91,0,0,0-1.34,2.72s0,.07,0,.11a.43.43,0,0,0,.05.12.73.73,0,0,0,.61.18h.43a.58.58,0,0,0,.23,0c.28-.1.61-.76.8-1l.53-.7,1.55-2-.19,0L126.84,19l-.91.77a.82.82,0,0,1-.05-1L127,16.57l.48-.93Z"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M129.87,16.94l-1.56,1.84c-.22.28-.93,1.46-.93,1.46s-.42.52-.21.82a9.52,9.52,0,0,0,.79.84,2.78,2.78,0,0,1,.86,1.9,15.22,15.22,0,0,1-.45,2.5l.76.3A7,7,0,0,0,129.3,23a3.06,3.06,0,0,0-1.32-2,1.16,1.16,0,0,1,.12-1.44c.62-.85,1.65-2.08,1.65-2.08l.26-.31Z"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M120.12,23.91s-.88,2.54-.46,3.86h0l-.3.11a4.54,4.54,0,0,1-1.09-2.26,3.43,3.43,0,0,1,.54-1.75l1.31,0"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M108.21,16.07l3.3,5s1.07,1,.65,5.55-1.52,6.35-2.42,7.84-2.48,7-1.62,8.4a19.49,19.49,0,0,0,.25,4.68,14.48,14.48,0,0,0,3.23,6.34c1.09,1.2,7.61,5.4,7.66,5.44A2.82,2.82,0,0,0,122.4,59c1.84-1.2,6.3-7.31,6.87-8.67S132,41.66,131.53,40a.59.59,0,0,1,.41.72c-.07.63-.6,4.53-.94,6a24.73,24.73,0,0,1-1.33,4.14c-.37.69-2.74,4.54-2.74,4.54l-3.61,4.25s-2.22,2.49-4.07,1h0l-3.81-2.42s-3.18-2.15-4.75-3.54-3.16-3.14-3.56-4.88a9.14,9.14,0,0,1,0-3.58l.33-1.8a6,6,0,0,1-.73-2.68,14.16,14.16,0,0,1,.44-3c.19-.66,1.4-3.65,1.4-3.65s.84-1.74,1.44-2.84a12.7,12.7,0,0,0,1.55-4.73,10.54,10.54,0,0,0-.59-5.28,31.91,31.91,0,0,0-1.9-3.58L108,17A2.53,2.53,0,0,1,108.21,16.07Z"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M115.09,18.66s.42-.36,1.24.1h0s-.15-1-.93-1.08-.31,1-.31,1"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M127.72,28.26l2.19.7s.37-1-.09-1.44-1.53-.09-2.1.74"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M128.89,31.32l1.23.72s.63-1.06,0-1.48-1.07.44-1.07.44Z"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M130.16,33.13l1.12.8s.56-.85,0-1.37-1.12.57-1.12.57"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M118.25,28.44s-2.57-3.11-1-5a4.78,4.78,0,0,1,3.63-1.65,7,7,0,0,1,2.09.35,7.23,7.23,0,0,1,1.91.83,4.49,4.49,0,0,1,1.29,1.35,6.19,6.19,0,0,1,.6,1.37l-1.1-.4s-.82-2-4-2.19h0s-2.38-.29-3.07,1h0s-1.17,1.74.84,3.7l-1.18.64"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M110,14.46l3,4.79.92-1s-.16.17-1.82-2.26l-1.16-1.9Z"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M121.55,28a4.46,4.46,0,0,1-1-.48c-.09-.15.83,0,.83,0L127,28.92a.34.34,0,0,1,.14.31,2.42,2.42,0,0,0,.1.67c.21.53.57.58.57.58Z"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M129.05,32.51s.21.37,1.11,0c0,0-.62.74-.44,1.19h0l-.67-1.16"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M127.79,30.6a2.23,2.23,0,0,0,1.2-.12s-.67.72-.51,1.24Z"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M124,58.83a0,0,0,0,1,0,.06,9.28,9.28,0,0,1-1.5,1.37,3.26,3.26,0,0,1-2.16.82,5,5,0,0,1-1.87-.95A68.8,68.8,0,0,1,112.34,56c-1.82-1.42-4-3.49-4.85-5.34a6.58,6.58,0,0,1-.61-1.88,14.37,14.37,0,0,1,.92-5.52A33,33,0,0,1,111,36.75a30.34,30.34,0,0,0-2,8.19,10.72,10.72,0,0,0,2.42,7.86c1.5,1.64,3.6,2.57,5.4,3.85A18.09,18.09,0,0,0,120.28,59,4.13,4.13,0,0,0,124,58.83Z"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M114.68,20.85a5.79,5.79,0,0,0-1.51,7.33,5.22,5.22,0,0,1,1,2.41A3.86,3.86,0,0,1,112.83,33,25.73,25.73,0,0,0,108,40.58c-.1.24-.24.51-.49.57a.55.55,0,0,1-.59-.41,1.71,1.71,0,0,1,0-.78,6.17,6.17,0,0,0,.51,4.34,41.12,41.12,0,0,1,8.19-13.8,6.13,6.13,0,0,1-.41-9.87A3.53,3.53,0,0,0,114.68,20.85Z"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M121.87,32.11A12.67,12.67,0,0,0,119.58,35a4.41,4.41,0,0,0-.33,3.61,4.29,4.29,0,0,0,3.25,2.42,9.77,9.77,0,0,0,4.19-.33,31.11,31.11,0,0,1,4.11-1,1,1,0,0,1,.84.15A41.66,41.66,0,0,0,127,41.24a10.19,10.19,0,0,1-4.76.5,4.59,4.59,0,0,1-3.6-2.87,4.75,4.75,0,0,1,.61-3.78A14.23,14.23,0,0,1,121.87,32.11Z"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M130.66,35.86a29.28,29.28,0,0,0-2.55-3.67,4.46,4.46,0,0,0-2-1.58,3.27,3.27,0,0,0-2,.06,9.62,9.62,0,0,0-1.8.87,8.2,8.2,0,0,1,2.56-1.28,3.68,3.68,0,0,1,2.64.22.53.53,0,0,1,.2.16c.35.55.73,1,1.05,1.51A16,16,0,0,1,130.66,35.86Z"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M126.42,25.51a4.19,4.19,0,0,0-1.8-2.24,6.34,6.34,0,0,0-2.78-.9,5.37,5.37,0,0,0-2.15.16A3,3,0,0,0,118,23.82a4,4,0,0,0,.06,3.32,1.56,1.56,0,0,0,.52.8.6.6,0,0,0,.85-.14A4.1,4.1,0,0,1,118.28,26a2.35,2.35,0,0,1,.35-2.06,2.44,2.44,0,0,1,1.4-.79,5.23,5.23,0,0,1,1.63-.05,5,5,0,0,1,3.44,1.38C125.5,24.92,125.84,25.54,126.42,25.51Z"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M121.06,24a7.58,7.58,0,0,0-1.27,3.68l-.43.16s-2-2.07-.56-4.15Z"
            style="
        fill: #231f20;
        opacity: 0.30000000000000004;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M115.4,17.68A.86.86,0,0,1,116,18a1.82,1.82,0,0,1,.29.72,1.18,1.18,0,0,1,0,.53.48.48,0,0,1-.35.35.59.59,0,0,1-.47-.23,1.86,1.86,0,0,1-.47-1,.85.85,0,0,1,.07-.5C115.18,17.76,115.23,17.68,115.4,17.68Z"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M115.51,30.58a10.81,10.81,0,0,1-2.23-3.22,5.31,5.31,0,0,1-.17-3.86,6,6,0,0,1,.55-1.27,7.1,7.1,0,0,1,2.15-1.93c.45-.27.93-.49,1.07-1.05"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M125.68,25.28a3.65,3.65,0,0,0-1.75-1.63,7.07,7.07,0,0,0-2.35-.59,3.38,3.38,0,0,0-2.61.56,2.41,2.41,0,0,0-.66,2.21,4.24,4.24,0,0,0,1,2.05"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M120.41,27.52c-2.85.77-5,3-6.81,5.38a38.27,38.27,0,0,0-6.08,11.61"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M127.78,30.58a4.48,4.48,0,0,0-4.31.22,11.25,11.25,0,0,0-3.25,3.09,10.24,10.24,0,0,0-1.45,2.3,3.91,3.91,0,0,0-.2,2.67,4.17,4.17,0,0,0,2,2.22,6.8,6.8,0,0,0,4,.81c2.35-.26,4.44-1.71,6.79-2"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M129.13,26.6c-3.41-1.37-6.64-2.62-10.32-2.8"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M129.62,27.38a.66.66,0,0,0-.25-.07,1.54,1.54,0,0,0-.92.2,2.08,2.08,0,0,0-.81.9,1.83,1.83,0,0,0-.25,1,1,1,0,0,0,.54.83,1.21,1.21,0,0,0,1-.1,2.17,2.17,0,0,0,1.1-2.25A.75.75,0,0,0,129.62,27.38Z"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M130.13,30.56a.48.48,0,0,0-.4-.06,1,1,0,0,0-.37.21,1.44,1.44,0,0,0-.41.47,1,1,0,0,0-.11.66.69.69,0,0,0,.58.55.81.81,0,0,0,.7-.35,1.28,1.28,0,0,0,.28-.81A1,1,0,0,0,130.13,30.56Z"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M131.28,32.56a.41.41,0,0,0-.37-.06.9.9,0,0,0-.36.19,1.38,1.38,0,0,0-.39.44.87.87,0,0,0-.1.61.63.63,0,0,0,.55.51.78.78,0,0,0,.67-.32,1.19,1.19,0,0,0,.27-.76A.87.87,0,0,0,131.28,32.56Z"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M127.78,30.58a2,2,0,0,0,1.9-.58"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M130.05,34.34c-.81-1.5-1.23-2.05-2.33-3.79"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M326.49,63.89l1,.08q.18-1,.3-1.92c0,.65.09,1.3.14,2l1.09.08q-.28-3.55-.34-7.13a1.73,1.73,0,0,0,.73.36.38.38,0,0,0,.43-.56,2.22,2.22,0,0,0-.57-.69,6.76,6.76,0,0,1-.62-.57,3.71,3.71,0,0,1-.27-.29,1.07,1.07,0,0,1-.14-.16l-.06-.07h0a2.5,2.5,0,0,1-.21-.35c0-.06-.06-.12-.09-.17l0-.06,0,0a1.17,1.17,0,0,1-.05-.11.5.5,0,1,0-1,.27,7.15,7.15,0,0,1,.09,1.2,28.38,28.38,0,0,1-.3,7.59C326.57,63.54,326.53,63.72,326.49,63.89Z"
            style="fill: #231f20; opacity: 0.2; mix-blend-mode: multiply"
          />
          <path
            d="M319.65,63.23l1.06.12c0-.34.06-.68.1-1,.23-2.15.56-4.29,1-6.42.14-.35.27-.7.44-1a.38.38,0,0,0-.06-.43,3,3,0,0,1-.55-2.07,12.16,12.16,0,0,1,.06-1.22,15.33,15.33,0,0,1,.67-2.83c.58-1.71,1.49-3.65,3.14-4.56a6.44,6.44,0,0,1,3-.45,9.37,9.37,0,0,0,2.95-.67,21.83,21.83,0,0,0,5.17-3.08,3.34,3.34,0,0,0,1.6-2h0l.17-2.63a6.41,6.41,0,0,0,2.49,1.44,2.9,2.9,0,0,0,1.33,0,.35.35,0,0,0-.14-.2L341.8,36a3.88,3.88,0,0,1-2.72-1.31l-.37-.41a4.82,4.82,0,0,1-.36-.43,7.29,7.29,0,0,1-1-1.39c-.29.13,0,.52-.06.8,0,0,.06,0,.09.08a.5.5,0,0,0,0,.12c0,1.15.06,2.31,0,3.46a3.17,3.17,0,0,1-.07.56.29.29,0,0,0-.18.1l-.34.41-.37.38-.36.37c-.08.09-.17.18-.24.27l-.2.14c-.89.62-1.9,1.14-2.89,1.69a18.13,18.13,0,0,1-3.08,1.55s-1.54,0-2.6.09a5.11,5.11,0,0,0-2.57.76,6,6,0,0,0-1.09,1,11.15,11.15,0,0,0-1.77,3.67,15.31,15.31,0,0,0-.76,3.33,11.09,11.09,0,0,0,0,3.59,10.31,10.31,0,0,0-.14,1.26c-.47,2.41-.69,3.76-1,6.19C319.71,62.57,319.68,62.9,319.65,63.23Z"
            style="fill: #231f20; opacity: 0.2; mix-blend-mode: multiply"
          />
          <path
            d="M365.37,63.63l-1,.1c0-.34,0-1.06-.06-1.4-.24-2.15-.57-4.29-1-6.42-.13-.35-.27-.7-.43-1a.36.36,0,0,1,.05-.43,3,3,0,0,0,.56-2.07,12.12,12.12,0,0,0-.07-1.22,15.3,15.3,0,0,0-.66-2.83c-.58-1.71-1.5-3.65-3.15-4.56a6.4,6.4,0,0,0-3-.45,9.37,9.37,0,0,1-2.95-.67,22.23,22.23,0,0,1-5.17-3.08,3.37,3.37,0,0,1-1.6-2h0l-.17-2.63a6.33,6.33,0,0,1-2.49,1.44,2.91,2.91,0,0,1-1.33,0,.43.43,0,0,1,.15-.2l.22-.12A3.88,3.88,0,0,0,346,34.67c.11-.14.24-.27.36-.41s.25-.28.37-.43a7.71,7.71,0,0,0,1-1.39,1.25,1.25,0,0,1-.08.52s.08.33.06.36a.49.49,0,0,1,0,.12c0,1.15-.06,2.31,0,3.46a3.17,3.17,0,0,0,.07.56.35.35,0,0,1,.19.1l.33.41.37.38.36.37c.08.09.17.18.24.27l.2.14c.91.63,2.2,1.3,3.33,2,.91.52,2.55,1.26,2.55,1.26.51.1,1.63,0,2.7.11a7.28,7.28,0,0,1,3,1.11c1.51,1.09,1.82,2.58,2.43,4.3a15.89,15.89,0,0,1,.75,3.33,5.09,5.09,0,0,1-.12,2.39A13,13,0,0,1,364,55c.47,2.41,1,4.8,1.3,7.23C365.38,62.57,365.34,63.3,365.37,63.63Z"
            style="fill: #231f20; opacity: 0.2; mix-blend-mode: multiply"
          />
          <path
            d="M355.61,57.31a1.67,1.67,0,0,0,.73-.36c0,2.47-.15,4.93-.35,7.38l1.08,0c.06-.75.12-1.49.16-2.23.09.7.2,1.4.33,2.09a.43.43,0,0,1,0,.11l1-.07c-.06-.27-.11-.54-.16-.82a48.16,48.16,0,0,1-.21-8.79.51.51,0,0,0-1-.27.36.36,0,0,1,0,.11v0l0,.06-.09.17c-.07.12-.14.24-.22.35h0l-.06.07-.14.16-.27.29c-.2.2-.41.39-.62.57a2.25,2.25,0,0,0-.58.69A.38.38,0,0,0,355.61,57.31Z"
            style="fill: #231f20; opacity: 0.2; mix-blend-mode: multiply"
          />
          <path
            d="M364.35,57.08c-.08-.27-.16-.55-.22-.83a2.53,2.53,0,0,1-.06-.61C364.16,56.12,364.26,56.6,364.35,57.08ZM347,38.05a1.61,1.61,0,0,1-.17-.51Zm-3.35-1.67c.31-.1.69-.24.29-.05a2.11,2.11,0,0,1,.91-.2,2.17,2.17,0,0,1-.69.21A4.75,4.75,0,0,1,343.65,36.38Z"
            style="fill: #231f20; opacity: 0.2; mix-blend-mode: multiply"
          />
          <path
            d="M340.45,41.06l-.4-.48-.09-.12,0,0,0,0-.18-.25a10.32,10.32,0,0,1-.6-1,.41.41,0,1,0-.71.42,6.27,6.27,0,0,0,.7,1.06,4.41,4.41,0,0,0,.91.87.32.32,0,0,0,.37-.05A.3.3,0,0,0,340.45,41.06Z"
            style="
        fill: #231f20;
        opacity: 0.301960784313726;
        mix-blend-mode: multiply;
      "
          />
          <path
            d="M344.22,41.06l.4-.48.09-.12,0,0,0,0,.18-.25a8.66,8.66,0,0,0,.6-1,.43.43,0,0,1,.57-.15.44.44,0,0,1,.15.57,5.77,5.77,0,0,1-.71,1.06,4.36,4.36,0,0,1-.9.87.31.31,0,0,1-.43-.43Z"
            style="
        fill: #231f20;
        opacity: 0.301960784313726;
        mix-blend-mode: multiply;
      "
          />
          <g style="opacity: 0.301960784313726; mix-blend-mode: multiply">
            <path
              d="M341.93,36.37c-.4,0-2.5-.13-4.59-3.62,0-.09-.27-.24-.18-.3a.19.19,0,0,1,.26.07C339.54,36.07,342,36,342,36h1s2.44.09,4.56-3.46a.2.2,0,0,1,.26-.07.19.19,0,0,1,.07.27c-2.24,3.76-4.79,3.65-4.9,3.65h-1Z"
              style="fill: #231f20"
            />
          </g>
          <path
            d="M346.39,60.26a9.83,9.83,0,0,0,3.11.13,21.81,21.81,0,0,0,2.88-.45,10.12,10.12,0,0,0,3.32-1.39c-.2,2-.44,3.89-.68,5.83l2-.1c.18-2.55.23-5.1.31-7.66a4.65,4.65,0,0,0,0,.7,8.67,8.67,0,0,0,.09,3.25s0,1.07,0,1.31c.1.78.12,1.59.28,2.36l2.07-.13c-.85-2.72-1.3-9.39-1.37-9.38a.83.83,0,0,0-.58-.86.74.74,0,0,0-.81.28c-.14.31-.14.31-.6.69a14.34,14.34,0,0,1-1.89,1.25c-.71.42-1.45.79-2.2,1.14s-1.5.67-2.28,1-1.46.42-2.18.65a10.13,10.13,0,0,0-1.45.21A.64.64,0,0,0,346.39,60.26Z"
            style="fill: #231f20; opacity: 0.2; mix-blend-mode: multiply"
          />
          <path
            d="M325.43,63.8l2,.17q.19-1,.33-2.07a.53.53,0,0,0-.25-.53,16.16,16.16,0,0,0,.12-4.39c.06.07,0-.16.06-.09.08,2.46.19,4.66.35,7.12l2,.14c-.23-1.87-.46-3.73-.65-5.6a10,10,0,0,0,3.31,1.39,21.7,21.7,0,0,0,2.89.45,9.77,9.77,0,0,0,3.1-.13.64.64,0,0,0,0-1.22,9.8,9.8,0,0,0-1.44-.21c-.72-.23-1.46-.4-2.18-.65a22.81,22.81,0,0,1-2.28-1c-.75-.35-1.49-.72-2.21-1.14a8.19,8.19,0,0,1-2-1.27,3.71,3.71,0,0,1-.5-.67.76.76,0,0,0-.82-.28.83.83,0,0,0-.57.86C326.64,54.72,326.2,61.18,325.43,63.8Z"
            style="fill: #231f20; opacity: 0.2; mix-blend-mode: multiply"
          />
          <path
            d="M321.62,63.45c0-.84.06-1.69.1-2.52a15.65,15.65,0,0,1,.69-3.84,4.83,4.83,0,0,0,.24-1.73c0-.66-.16-1.31-.18-2a12.64,12.64,0,0,1,1.54-7,4.17,4.17,0,0,1,2.28-2.09,23.78,23.78,0,0,1,3.57-.5A12.07,12.07,0,0,0,334,42.43a15.49,15.49,0,0,0,3.13-2.26,9.4,9.4,0,0,0,.66-.74s.6-2.89,1.16-2.81a2,2,0,0,1,2.25-.2l.37,0,.58-.15.12,0a2.74,2.74,0,0,1-.62-.18l-.41-.21a3.68,3.68,0,0,1-2.11-1.22l-.32-.37a3.25,3.25,0,0,1-.35-.39,9,9,0,0,1-.78-1c-.45.15-.27.89-.27.89s0,.31,0,.33c0,.45-.23.94,0,1.34a12.64,12.64,0,0,1,0,1.5c0,1.07-1.17,1.78-2,2.4a24.41,24.41,0,0,1-3.06,1.75,8.66,8.66,0,0,1-3.42,1.21,17.45,17.45,0,0,0-3.6.74,4.21,4.21,0,0,0-2.58,2.32,18.11,18.11,0,0,0-1.85,7.1,11.59,11.59,0,0,0,.09,1.86,5.56,5.56,0,0,1-.17,1.94c-.14.59-.26,1.15-.39,1.75s-.25,1.47-.35,2.18c-.14,1-.27,2-.32,3Z"
            style="fill: #231f20; opacity: 0.2; mix-blend-mode: multiply"
          />
          <path
            d="M343.69,36.4c.32-.1.7-.24.3,0a2.14,2.14,0,0,1,2.27.29c.55,0,1.13,2.76,1.14,2.81a9.4,9.4,0,0,0,.66.74,15.07,15.07,0,0,0,3.13,2.25,11.9,11.9,0,0,0,4.08,1.43,23.59,23.59,0,0,1,3.57.49,4.17,4.17,0,0,1,2.29,2.1,12.64,12.64,0,0,1,1.54,6.95c0,.66-.15,1.31-.19,2a5.07,5.07,0,0,0,.25,1.73,16.14,16.14,0,0,1,.69,3.83c.05,1,.08,1.92.11,2.89l1.79-.17c-.05-1.17-.13-2.33-.29-3.48-.1-.71-.22-1.43-.37-2.13s-.18-1.18-.32-1.78a5.34,5.34,0,0,1-.17-1.9c0-.19,0-.43,0-.62a13.93,13.93,0,0,0,.09-1.45,14.17,14.17,0,0,0-1.85-6.93,7.68,7.68,0,0,0-1-1.5A5.44,5.44,0,0,0,360,43a9.69,9.69,0,0,0-3.67-.64c-.29,0-.6.14-.88,0a17.38,17.38,0,0,1-2.54-1.22,24.5,24.5,0,0,1-3-1.72c-.83-.62-1.82-1.22-2.11-2.24a11.6,11.6,0,0,1,0-1.54c0-.5,0-.82,0-1.27,0,0-.05-.38,0-.41,0-.82-.07-1.06-.2-1.06a8.79,8.79,0,0,1-.79,1,4.13,4.13,0,0,1-.34.39l-.32.36a3.72,3.72,0,0,1-2.12,1.23l-.4.21a1.17,1.17,0,0,1-.38.12h0Z"
            style="fill: #231f20; opacity: 0.2; mix-blend-mode: multiply"
          />
          <path
            d="M335.81,25.76s.84,4.94,1,5.23,1.47,3.52,3.69,4.26a6,6,0,0,0,4.35,0c.6-.27,3.45-4.1,3.45-4.1a19.42,19.42,0,0,0,.9-5.39s0,.39.61.6.36,1.3.36,1.3a8.69,8.69,0,0,1-.73,2.44,2.23,2.23,0,0,1-.72.81l-.7,1.16-.38.75s-1.51,2.93-3.08,3.15a18.48,18.48,0,0,1-3.1.16,3.83,3.83,0,0,1-2.41-1.32,13.79,13.79,0,0,1-1.74-2.13l-1-1.73a1.92,1.92,0,0,1-.74-.8,9.79,9.79,0,0,1-.78-2.64c-.08-.92.26-1.08.26-1.08a3.86,3.86,0,0,0,.55-.29A.4.4,0,0,0,335.81,25.76Z"
            style="fill: #231f20; opacity: 0.05; mix-blend-mode: multiply"
          />
          <path
            d="M341.24,29.88a3.54,3.54,0,0,0,2.82,0,3.32,3.32,0,0,1-1.54.67A2.45,2.45,0,0,1,341.24,29.88Z"
            style="fill: #231f20; opacity: 0.05; mix-blend-mode: multiply"
          />
          <path
            d="M341.52,25.19a20.35,20.35,0,0,1-3.19-.24.14.14,0,0,0-.16.15s0,0,.06,0a21.66,21.66,0,0,0,3.2.24.14.14,0,0,1,.14.14l0,1.18a.17.17,0,0,0,.1-.13l0-1.19A.15.15,0,0,0,341.52,25.19Z"
            style="fill: #231f20; opacity: 0.05; mix-blend-mode: multiply"
          />
          <path
            d="M343.8,25.19A20.35,20.35,0,0,0,347,25a.14.14,0,0,1,.16.15s0,0-.06,0a21.66,21.66,0,0,1-3.2.24.14.14,0,0,0-.14.14l0,1.18a.14.14,0,0,1-.09-.13l0-1.19A.15.15,0,0,1,343.8,25.19Z"
            style="fill: #231f20; opacity: 0.05; mix-blend-mode: multiply"
          />
          <path
            d="M319.67,63.24c2.19.24,4.78.5,7.71.72a13.06,13.06,0,0,0,.22-1.69s.12-3.25.12-5.38l.2,7.11a223.38,223.38,0,0,0,29.17.27l.2-7.38c0,2.13.12,5.38.12,5.38a15.75,15.75,0,0,0,.27,2q3.78-.22,7.69-.61a39.38,39.38,0,0,0-1-7,11,11,0,0,1-.29-3.39A13.81,13.81,0,0,0,361.48,44c-1.49-1.83-5.1-1.71-5.93-1.65a.64.64,0,0,1-.33-.07c-.64-.3-3-1.45-4.62-2.39a9.39,9.39,0,0,1-2.75-2.38.7.7,0,0,1-.13-.39L347.64,33a.66.66,0,0,1,.08-.34l.86-1.55a.56.56,0,0,1,.31-.25c.55-.27,1.06-1.95,1.31-3.31.15-.83-.19-1.11-.53-1.2a.66.66,0,0,1-.47-.73l0-.3s0-.07,0-.1c0-6.9-5.21-7.95-5.21-7.95a5.49,5.49,0,0,0-3.06,0s-5.19,1.05-5.21,8v.1l0,.3a.65.65,0,0,1-.47.73c-.34.09-.68.37-.52,1.2.25,1.36.75,3,1.31,3.31a.63.63,0,0,1,.31.25l.85,1.55a.57.57,0,0,1,.08.34l-.07,4.19a.71.71,0,0,1-.14.39,9.39,9.39,0,0,1-2.75,2.38c-1.65.94-4,2.09-4.61,2.39a.67.67,0,0,1-.34.07c-.83-.06-4.44-.18-5.93,1.65a13.81,13.81,0,0,0-2.62,9.21,11,11,0,0,1-.29,3.39A39.55,39.55,0,0,0,319.67,63.24Z"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M64.24,175l-.24.2S64,175.12,64.24,175Z"
            style="fill: #b9bbbd"
          />
          <path
            d="M21.7,194.35a1.32,1.32,0,0,1-.19-1.61l0,0a1.32,1.32,0,0,0,1.89,1.85l0,0A1.31,1.31,0,0,1,21.7,194.35Z"
            style="fill: #231f20; opacity: 0.2"
          />
          <path
            d="M36.52,181a11.05,11.05,0,1,0-1.44-15.56A11,11,0,0,0,36.52,181Zm13.85-16.66a10.35,10.35,0,1,1-14.57,1.34A10.33,10.33,0,0,1,50.37,164.31Z"
            style="opacity: 0.2"
          />
          <path
            d="M54.64,176A11.74,11.74,0,1,0,40,183.9,11.74,11.74,0,0,0,54.64,176Zm-21.58-6.48a11.06,11.06,0,1,1,7.41,13.77A11.06,11.06,0,0,1,33.06,169.56Z"
            style="opacity: 0.2"
          />
          <path
            d="M51.69,164.36a11.74,11.74,0,1,0,0,16.6A11.75,11.75,0,0,0,51.69,164.36ZM35.77,180.29a11.05,11.05,0,1,1,15.63,0A11,11,0,0,1,35.77,180.29Z"
            style="opacity: 0.2"
          />
          <path
            d="M22.44,191.7l9.33-9.32a1.56,1.56,0,0,1,1.12-.47c-.07-.2,0-.29,0-.29l.13-.13a1.62,1.62,0,0,0-1.84.3l-9.32,9.32a1.61,1.61,0,0,0,0,2.28l.58.59A1.63,1.63,0,0,1,22.44,191.7Z"
            style="fill: #231f20; opacity: 0.2"
          />
          <path
            d="M34.61,183l-.18.18a.17.17,0,0,1-.13,0,1.69,1.69,0,0,1-.52,1.18l-9.32,9.32a1.5,1.5,0,0,1-2.1.18l.49.5a1.52,1.52,0,0,0,2.1-.18l9.32-9.32A1.58,1.58,0,0,0,34.61,183Z"
            style="fill: #231f20; opacity: 0.2"
          />
          <path
            d="M33.42,182.65c-.75-.75-.53-1-.53-1l.14-.14a1.62,1.62,0,0,0-1.86.3l-9.32,9.32a1.61,1.61,0,0,0,0,2.28l.58.59C21.87,193.4,30.32,184.84,33.42,182.65Z"
            style="fill: #231f20; opacity: 0.2"
          />
          <path
            d="M34.7,181.36a10,10,0,0,1-.74-.81l-.24.24s.26.32.74.8a6.52,6.52,0,0,0,.81.74l.23-.23A7.65,7.65,0,0,1,34.7,181.36Z"
            style="fill: #231f20; opacity: 0.2"
          />
          <g style="opacity: 0.2">
            <path
              d="M33.13,181.86l1.07-1.07a2.66,2.66,0,0,1-.22-.26l-1.09,1.09s-.24.24.53,1l.12.11C32.91,182.07,33.13,181.86,33.13,181.86Z"
              style="fill: #231f20"
            />
          </g>
          <path
            d="M52.45,181.34a12.54,12.54,0,1,0-17.73,0c-.23-.23-.4-.41-.52-.55h0a2.66,2.66,0,0,1-.22-.26l0,0-.14.14-.1.1-.69.69a1.62,1.62,0,0,0-1.86.3l-9.32,9.32a1.62,1.62,0,0,0-.39,1.64,1.32,1.32,0,0,0,1.86,1.86,1.61,1.61,0,0,0,1.63-.39l9.32-9.32a1.62,1.62,0,0,0,.3-1.86l.7-.7h0l.23-.23h0l0,0a7.65,7.65,0,0,1-.8-.74h0A12.53,12.53,0,0,0,52.45,181.34Zm-16.68-1.05a11.05,11.05,0,1,1,15.63,0A11,11,0,0,1,35.77,180.29Z"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M34.57,183l-.14.14s-.24.24-1-.53-.53-1-.53-1l.14-.14a1.62,1.62,0,0,0-1.86.3l-9.32,9.32a1.61,1.61,0,0,0,0,2.28l.82.83a1.63,1.63,0,0,0,2.28,0l9.32-9.32A1.62,1.62,0,0,0,34.57,183Z"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M52.45,163.61a12.54,12.54,0,1,0,0,17.73A12.53,12.53,0,0,0,52.45,163.61ZM35.77,180.29a11.05,11.05,0,1,1,15.63,0A11,11,0,0,1,35.77,180.29Z"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M22.67,194.21l-.82-.83a1.43,1.43,0,0,1-.39-.64,1.32,1.32,0,0,0,1.86,1.86A1.74,1.74,0,0,1,22.67,194.21Z"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M450.85,180.89l-.23.2S450.64,181.06,450.85,180.89Z"
            style="fill: #b9bbbd"
          />
          <path
            d="M408.32,200.29a1.33,1.33,0,0,1-.2-1.62l0,0a1.32,1.32,0,0,0,1.88,1.85l0,0A1.32,1.32,0,0,1,408.32,200.29Z"
            style="fill: #231f20; opacity: 0.2"
          />
          <path
            d="M423.13,186.91a11.06,11.06,0,1,0-1.43-15.57A11.06,11.06,0,0,0,423.13,186.91ZM437,170.24a10.35,10.35,0,1,1-14.58,1.34A10.35,10.35,0,0,1,437,170.24Z"
            style="opacity: 0.2"
          />
          <path
            d="M441.25,182a11.74,11.74,0,1,0-14.62,7.87A11.73,11.73,0,0,0,441.25,182Zm-21.57-6.48a11.06,11.06,0,1,1,7.41,13.77A11.06,11.06,0,0,1,419.68,175.49Z"
            style="opacity: 0.2"
          />
          <path
            d="M438.31,170.29a11.74,11.74,0,1,0,0,16.6A11.75,11.75,0,0,0,438.31,170.29Zm-15.93,15.93a11.06,11.06,0,1,1,15.64,0A11.06,11.06,0,0,1,422.38,186.22Z"
            style="opacity: 0.2"
          />
          <path
            d="M409.06,197.63l9.32-9.32a1.64,1.64,0,0,1,1.12-.47.36.36,0,0,1,0-.29l.14-.13a1.61,1.61,0,0,0-1.84.31l-9.32,9.32a1.6,1.6,0,0,0,0,2.27l.58.59A1.63,1.63,0,0,1,409.06,197.63Z"
            style="fill: #231f20; opacity: 0.2"
          />
          <path
            d="M421.23,188.92l-.18.18a.18.18,0,0,1-.13,0,1.76,1.76,0,0,1-.52,1.19l-9.32,9.32a1.51,1.51,0,0,1-2.1.17l.49.5a1.5,1.5,0,0,0,2.1-.18l9.32-9.32A1.58,1.58,0,0,0,421.23,188.92Z"
            style="fill: #231f20; opacity: 0.2"
          />
          <path
            d="M420,188.58c-.75-.75-.53-1-.53-1l.14-.14a1.61,1.61,0,0,0-1.85.31L408.47,197a1.6,1.6,0,0,0,0,2.27l.58.59C408.49,199.33,416.93,190.77,420,188.58Z"
            style="fill: #231f20; opacity: 0.2"
          />
          <path
            d="M421.32,187.29c-.49-.49-.75-.81-.75-.81l-.23.24a9.13,9.13,0,0,0,.74.8,7.8,7.8,0,0,0,.81.75l.23-.24A6.23,6.23,0,0,1,421.32,187.29Z"
            style="fill: #231f20; opacity: 0.2"
          />
          <g style="opacity: 0.2">
            <path
              d="M419.74,187.79l1.07-1.07-.22-.26-1.09,1.09s-.24.24.54,1l.12.11C419.53,188,419.74,187.79,419.74,187.79Z"
              style="fill: #231f20"
            />
          </g>
          <path
            d="M439.07,187.27a12.54,12.54,0,1,0-17.74,0c-.22-.22-.39-.41-.52-.55h0l-.22-.26,0,0-.13.14-.1.1-.7.69a1.61,1.61,0,0,0-1.85.31L408.47,197a1.58,1.58,0,0,0-.39,1.63,1.32,1.32,0,0,0,1.85,1.86,1.62,1.62,0,0,0,1.64-.39l9.32-9.32a1.62,1.62,0,0,0,.3-1.86l.7-.69h0l.23-.24h0l0,0a6.52,6.52,0,0,1-.81-.74h0A12.54,12.54,0,0,0,439.07,187.27Zm-16.69-1.05a11.06,11.06,0,1,1,15.64,0A11.06,11.06,0,0,1,422.38,186.22Z"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M421.19,189l-.14.14s-.24.24-1-.53-.54-1-.54-1l.14-.14a1.61,1.61,0,0,0-1.85.31L408.47,197a1.6,1.6,0,0,0,0,2.27l.82.83a1.61,1.61,0,0,0,2.28,0l9.32-9.32A1.62,1.62,0,0,0,421.19,189Z"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M439.07,169.54a12.54,12.54,0,1,0,0,17.73A12.54,12.54,0,0,0,439.07,169.54Zm-16.69,16.68a11.06,11.06,0,1,1,15.64,0A11.06,11.06,0,0,1,422.38,186.22Z"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
          <path
            d="M409.29,200.14l-.82-.83a1.43,1.43,0,0,1-.39-.64,1.32,1.32,0,0,0,1.85,1.86A1.78,1.78,0,0,1,409.29,200.14Z"
            style="
        fill: none;
        stroke: #231f20;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 0.467631316910455px;
      "
          />
        </g>
      </svg>
    `;
  }
}

customElements.define("clinical-burdens", ClinicalBurdens);
